import { typedKeys } from '@reckon-web/utils';

// ==============================
// Palette Definition
// ==============================

export const workflowPaletteDefinition = {
  // 200 range from tailwind
  'gray-light': { value: '#e5e7eb', label: 'Light gray' },
  'red-light': { value: '#fecaca', label: 'Light red' },
  'orange-light': { value: '#fed7aa', label: 'Light orange' },
  'yellow-light': { value: '#fef08a', label: 'Light yellow' },
  'lime-light': { value: '#d9f99d', label: 'Light lime' },
  'green-light': { value: '#bbf7d0', label: 'Light green' },
  'teal-light': { value: '#99f6e4', label: 'Light teal' },
  'blue-light': { value: '#bfdbfe', label: 'Light blue' },
  'purple-light': { value: '#e9d5ff', label: 'Light purple' },
  'pink-light': { value: '#fbcfe8', label: 'Light pink' },
  // 600 range from tailwind
  gray: { value: '#4b5563', label: 'Gray' },
  red: { value: '#dc2626', label: 'Red' },
  orange: { value: '#ea580c', label: 'Orange' },
  yellow: { value: '#ca8a04', label: 'Yellow' },
  lime: { value: '#65a30d', label: 'Lime' },
  green: { value: '#16a34a', label: 'Green' },
  teal: { value: '#0d9488', label: 'Teal' },
  blue: { value: '#2563eb', label: 'Blue' },
  purple: { value: '#9333ea', label: 'Purple' },
  pink: { value: '#db2777', label: 'Pink' },
} as const;

export type WorkflowPalette = typeof workflowPaletteDefinition;
export type WorkflowPaletteKey = keyof WorkflowPalette;

export const workflowPaletteKeys: ReadonlyArray<WorkflowPaletteKey> = typedKeys(
  workflowPaletteDefinition
);

export const workflowPalette = workflowPaletteKeys.map((key) => {
  const { value, label } = workflowPaletteDefinition[key];
  return { key, label, value };
});
